<template>
  <div class="container">
    <h1>Claim already exists</h1>
    <span>This claim already exists. View the details below.</span>
  </div>
</template>
